import { useEffect, useState } from 'react';
import { Card, useTheme } from '@mui/material';
import { H5 } from 'components/Typography';
import Chart from 'react-apexcharts';
import axiosInstance from 'utils/axios';

const ReRegistrationStatus = () => {
    const theme = useTheme();
    const [data, setData] = useState();

    useEffect(() => {
        const getData = async () => {
            await axiosInstance
                .get('api/prv/summaries/re-registration')
                .then(({ data }) => setData(data))
                .catch((err) => console.log(err));
        };
        getData();
    }, []);

    const chartOptions = {
        colors: [theme.palette.primary.main, theme.palette.success.main],
        chart: {
            stacked: false,
            background: 'transparent',
            sparkline: {
                enabled: true,
            },
            fontFamily: theme.typography.fontFamily,
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '60%',
                    labels: {
                        show: true,
                        total: {
                            show: true,
                            showAlways: true,
                            label: 'Total',
                            fontSize: '30px',
                            fontFamily: 'Helvetica, Arial, sans-serif',
                            fontWeight: 600,
                            color: theme.palette.text.primary,
                            formatter: function (w) {
                                return w.globals.seriesTotals.reduce((a, b) => {
                                    return a + b;
                                }, 0);
                            },
                        },
                    },
                },
            },
        },
        states: {
            normal: {
                filter: {
                    type: 'none',
                },
            },
            hover: {
                filter: {
                    type: 'none',
                },
            },
            active: {
                filter: {
                    type: 'none',
                },
            },
        },
        labels: ['Already Re-registered', 'Not Yet'],
        theme: {
            mode: theme.palette.mode,
        },
        legend: {
            show: true,
            position: 'bottom',
            fontSize: '13px',
            fontWeight: 500,
            itemMargin: {
                horizontal: 10,
            },
            onItemClick: {
                toggleDataSeries: false,
            },
            onItemHover: {
                highlightDataSeries: false,
            },
            offsetY: 0,
        },
        tooltip: {
            theme: 'light',
            style: {
                fontSize: '13px',
            },
            fillSeriesColor: false,
        },
        stroke: {
            width: 0,
        },
    };
    return (
        <Card
            sx={{
                padding: 3,
                height: '100%',
            }}
        >
            <H5 mb={3} textAlign="center">
                Re-registration Status
            </H5>
            <Chart
                height={370}
                type="donut"
                options={chartOptions}
                series={[data?.registered || 0, data?.notYet || 0]}
            />
        </Card>
    );
};

export default ReRegistrationStatus;
